import React, { useCallback, useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { parseNumberByPrecision, useOutsideClick } from '@pascal/pascal-core';
import { freeBetStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';

import { gameStore } from '../../store/gameStore';
import { doBetStore } from '../../store/doBetStore';
import { autoBetStore } from '../../store/autoBetStore';
import { soundService, soundTypes } from '../../services/SoundService';

const AmountSection = observer(() => {
  const { quickBets, selectedAmount, setSelectedAmount } = doBetStore;
  const { autoBetCount, isPlay } = autoBetStore;
  const { precision } = userInfoStore;
  const { activeFreeBet } = freeBetStore;
  const { isBetsClosed } = gameStore;
  const quickBetsRef = useRef();
  const [opened, handleClick] = useOutsideClick(quickBetsRef);

  useEffect(() => {
    if (activeFreeBet.id) {
      setSelectedAmount(activeFreeBet.amount);
      soundService.play(soundTypes.chip);
    }
    return () => setSelectedAmount(quickBets[quickBets.length - 1]);
  }, [activeFreeBet.id]);

  const handleSelectAmount = useCallback(
    (amount) => {
      setSelectedAmount(amount);
      soundService.play(soundTypes.chip);
    },
    [setSelectedAmount]
  );

  return (
    <div
      ref={quickBetsRef}
      onClick={() => {
        if (!activeFreeBet.id) {
          return handleClick();
        }
      }}
      className={`action-btn-el ${opened ? 'active-dropdown' : ''} ${
        autoBetCount || isBetsClosed ? 'inactive' : ''
      }`}
    >
      <button
        type='button'
        aria-label='amount'
        className='icon-coins action-btn'
        disabled={isBetsClosed || (autoBetCount && isPlay)}
      />
      <div className='action-btn-el-value'>
        <p className='action-dropdown-selected active'>
          {parseNumberByPrecision(1, +selectedAmount, precision)}
        </p>
        <ul className='action-dropdown'>
          {activeFreeBet.id ? (
            <li
              key={activeFreeBet.amount}
              className={`action-dropdown-el ${
                activeFreeBet.amount === selectedAmount ? 'active' : ''
              }`}
            >
              {activeFreeBet.amount}
            </li>
          ) : (
            quickBets.map((item) => {
              const amount = parseNumberByPrecision(1, item, precision);
              return (
                <li
                  key={item}
                  className={`action-dropdown-el ${item === selectedAmount ? 'active' : ''}`}
                  onClick={() => {
                    handleSelectAmount(amount);
                  }}
                >
                  {amount}
                </li>
              );
            })
          )}
        </ul>
      </div>
    </div>
  );
});

export default AmountSection;
